export const BASE_URL = process.env.REACT_APP_BASE_URL;
// export const BASE_URL = 'https://asset.kanoks.me'

export const SYNC_SMS_URL = process.env.REACT_APP_SYNC_URL;
